import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => (
  {
    root: {
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#ccc',
      display: 'flex',
      justifyContent: 'center',
      backgroundPosition: "bottom left",
      backgroundRepeat: "no-repeat",
      backgroundSize: 'contain',
    },
  
     pageHeading: {
        color: '#1A4664',
        fontFamily: 'Montserrat',
        fontSize: '22px',
        fontWeight: '700',
        letterSpacing: '0.18px',
        lineHeight: '24px',
        marginBottom: 25,
        marginTop: 24
    },
    infoStrip: {
      backgroundColor: '#FFFFFF',
      width: '100%',
      padding: '20px 44px 20px 44px',
      border:'1px solid #B4B4B4',
      borderRadius : '10px'
    },
    
    infoBox: {
      backgroundColor: '#7EB1CC',
      margin: '40px',
      border:'1px solid #B4B4B4',
      borderRadius : '10px',
      padding: '15px'
    },
    
    icon: {
        margin: '20px 10px 20px 20px',
        fontSize: '30px',
        color: '#444444',
        height: '23px',
        width: '23px'
      },
    
    line: {
      border: '1px solid #E4E4E4'
    },

    infoText: {
      color: '#474747',
      fontFamily: "Montserrat",
      fontSize: "16px",
      lineHeight: "22px",
      fontWeight: '400',
      padding: '5px 20px 20px 16px'
    },
    
    infoHeading: {
      color: '#626262',
      fontFamily: "Montserrat",
      fontSize: "18px",
      lineHeight: "22px",
      fontWeight: '700',
      padding: '26px 20px 5px 16px'
    },

    container: {
      width: '120em',
      minWidth: "33.3em",
      marginTop: '3.6em',
      marginBottom: '6.6em',
      [theme.breakpoints.down('sm')]: {
        margin: '42px 16px',
      },
    },
 
    infoIcon: {
      padding: "6px 6px",
      fontSize: '30px',
      color: theme.palette.secondary.contrastText,
    },
    
    procedureToFill: {
        color: '#1B1B1B',
        fontFamily: "Montserrat",
        fontSize: 18,
        lineHeight: "22px",
        fontWeight: '700'
    },

    readInst: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "24px",
        fontWeight: '400'
    },

    line: {
      border: '1px solid #D9D9D9'
    },

    downloadForm: {
        color: '#235A86',
        fontFamily: "Montserrat",
        fontSize: 18,
        lineHeight: "24px",
        fontWeight: '700'
    },

    instruction: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "32px",
        fontWeight: '400'
    },

    downloadInst: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "32px",
        fontWeight: '600'
    },

    linkStyle: {
        fontFamily: "Montserrat",
        fontSize: '1em',
        color: '#007FFF',
        fontWeight: '600',
        letterSpacing: '0.6px',
        textDecoration: 'underline',
        cursor: "pointer"
      },
    
      btn: {
        backgroundColor: '#1A4664',
        fontFamily: "Montserrat",
        fontSize: 14,
        fontWeight: '600',
        height: 32,
        width: 186,
        color: '#FFFFFF',
        width: 186,
        marginBottom: 10,
        marginTop: 10,
        '&:hover': {
            backgroundColor: '#1A4664'
          },
      },

      supportedDoc: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 18,
        lineHeight: "24px",
        fontWeight: '600'
      },

      supportedDocContainer: {
        backgroundColor: '#FFFFFF',
        width: '100%',
        padding: '12px 20px 12px 38px',
        border:'1px solid #B4B4B4',
        borderRadius : '10px'
      },

      footerSection: {
        paddingTop: 35,
        paddingBottom: 30
      },

      cancelBtn: {
        width: 192,
        fontFamily: "Montserrat",
        fontSize: '1.6em',
        fontWeight: "600",
        letterSpacing: "0.53px",
        lineHeight: "19px",
        textAlign: "center",
        float: "right",
        border: "2px solid",
        height: '40px',
        boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
        borderColor: theme.palette.primary.main,
        [theme.breakpoints.down('xs')]: {
          width: 'auto',
        },
      },

      saveBtnBox: {
        float: "left",
        [theme.breakpoints.down('sm')]: {
          float: "right",
          paddingRight: 15
        }
      },
    
      saveBtn: {
        width: 192,
        fontFamily: "Montserrat",
        fontSize: '1.6em',
        marginLeft: 20,
        fontWeight: "600",
        letterSpacing: "0.53px",
        lineHeight: "19px",
        textAlign: "center",
        height: '40px',
        [theme.breakpoints.down('xs')]: {
          width: 'auto',
        },
      },

      play: {
        color: '#235A86',
        borderRadius: '4px',
        border: '1.5px solid #235A86',
        backgroundColor: '#FFFFFF',
        cursor: "pointer",
        textAlign: 'center',
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '600',
        lineHeight: 'normal',
        textTransform: 'uppercase',
        width: '230px',
        float: 'right',
        '&:hover': {
            backgroundColor: '#FFFFFF'
          },
        [theme.breakpoints.down('xs')]: {
           fontSize: 12,
           float: 'left',
           width: '212px'
        }
      }
    
  }
));

